export enum LodgerTypeCode {
  SingleGuest = 16,
  FamilyLeader = 17,
  GroupLeader = 18,
  FamilyMember = 19,
  GroupMember = 20,
}
